import IndustryCard from './IndustryCard';

export default IndustryCard;
